import { LandingPageTemplateWebComponent } from './component/LandingPageTemplateWebComponent';

export { LandingPageTemplateWebComponent };
